<template>
  <img src="/images/promo/hero-section/clock.png"
   alt="Clock" />
</template>

<script>
export default {};
</script>
